import styled from 'styled-components';

import { AmendmentListItem } from '@xemplo/gp-types';
import {
  BodySmallMedium,
  BodyXSmallMedium,
  BodyXSmallRegular,
  Colour,
  MinBreakpoint,
} from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';

export const Table = styled(XemploTable<AmendmentListItem>)`
  background: transparent;
  ${BodyXSmallRegular};
  color: ${Colour.Gray[500]};

  .action-bar-container {
    border-radius: 8px;
    position: relative;
    box-sizing: content-box;
  }

  table {
    background: transparent;
    thead {
      border: none;
      color: ${Colour.Gray[500]};
      ${BodyXSmallMedium};
    }

    tbody {
      background: transparent;
      ${BodyXSmallRegular};
      tr {
        box-sizing: border-box;
        background: ${Colour.Light[100]};
        margin-bottom: 8px;
        border-radius: 8px;
        height: 76px;
        border: 1px solid transparent;
        &.active {
          box-sizing: border-box;
          border-radius: 8px;
          border: 1px solid ${Colour.Blue[500]};
          background: rgba(11, 120, 255, 0.08);
        }
      }
      td {
        &:first-child {
          color: ${Colour.Gray[700]};
          ${BodySmallMedium};
        }
      }
    }
  }
`;

export const WorkerCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const WorkerName = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[700]};
`;

export const LeadIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${Colour.Blue[50]};
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    width: 20px;
    height: 20px;
    color: ${Colour.Blue[500]};
  }
`;

export const Container = styled.div`
  overflow-x: auto;

  @media ${MinBreakpoint.xxxlarge} {
    grid-area: 1 / 1;
  }
`;
